<template>
  <div id="excel-estimaciones">
    <custom-button
      label="Exportar"
      iconText="fa-file-excel"
      tipo="agregar"
      class="mr-2"
      :loading="estaCargando"
      @click="generarExcelEstimaciones">
    </custom-button>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ExcelEstimaciones',
  mixins: [mixGenerarExceles],
  props: {
    estimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      estaCargando: false,
      nombreDocumento: 'ESTIMACIONES',
      headers: [
        {
          value: 'Número', nombreColumna: 'numero', seSuma: false, esObraFinanciada: false, orden: 1,
        },
        {
          value: 'Fecha Del', nombreColumna: 'fechaDel', seSuma: false, esObraFinanciada: false, orden: 2,
        },
        {
          value: 'Fecha Al', nombreColumna: 'fechaAl', seSuma: false, esObraFinanciada: false, orden: 3,
        },
        {
          value: 'Directo', nombreColumna: 'importeCostoDirecto', seSuma: true, esObraFinanciada: true, orden: 4,
        },
        {
          value: 'Indirectos', nombreColumna: 'importeCostoIndirectos', seSuma: true, esObraFinanciada: true, orden: 5,
        },
        {
          value: 'Utilidad', nombreColumna: 'importeUtilidad', seSuma: true, esObraFinanciada: true, orden: 6,
        },
        {
          value: 'Adicionales', nombreColumna: 'importeCargosAdicionales', seSuma: true, esObraFinanciada: true, orden: 7,
        },
        {
          value: 'Estimado', nombreColumna: 'importeEstimado', seSuma: true, esObraFinanciada: false, orden: 8,
        },
        {
          value: 'Amort. Ant.', nombreColumna: 'importeAmortizacionAnticipo', seSuma: true, esObraFinanciada: false, orden: 9,
        },
        {
          value: 'Subtotal', nombreColumna: 'subtotal', seSuma: true, esObraFinanciada: false, orden: 10,
        },
        {
          value: 'C. Financiero', nombreColumna: 'importeCostoFinanciero', seSuma: true, esObraFinanciada: true, orden: 11,
        },
        {
          value: 'Subtotal 2', nombreColumna: 'subtotalDos', seSuma: true, esObraFinanciada: true, orden: 12,
        },
        {
          value: 'IVA', nombreColumna: 'importeIva', seSuma: true, esObraFinanciada: false, orden: 13,
        },
        {
          value: 'Facturado', nombreColumna: 'totalFactura', seSuma: true, esObraFinanciada: false, orden: 14,
        },
        {
          value: 'Deducciones', nombreColumna: 'importeDeducciones', seSuma: true, esObraFinanciada: false, orden: 15,
        },
        {
          value: 'Retenido', nombreColumna: 'importeRetenido', seSuma: true, esObraFinanciada: false, orden: 16,
        },
        {
          value: 'Devuelto', nombreColumna: 'importeDevuelto', seSuma: true, esObraFinanciada: false, orden: 17,
        },
        {
          value: 'Sanción', nombreColumna: 'importeSancion', seSuma: true, esObraFinanciada: false, orden: 18,
        },
        {
          value: 'Ajuste', nombreColumna: 'importeBonificacion', seSuma: true, esObraFinanciada: false, orden: 19,
        },
        {
          value: 'Líquido', nombreColumna: 'importeLiquido', seSuma: true, esObraFinanciada: false, orden: 20,
        },
        {
          value: 'Estatus de Pago', nombreColumna: 'estatusPago', seSuma: false, esObraFinanciada: false, orden: 21,
        },
        {
          value: 'Fecha', nombreColumna: 'fechaPago', seSuma: false, esObraFinanciada: false, orden: 22,
        },
        {
          value: 'Folio de Pago', nombreColumna: 'folioPago', seSuma: false, esObraFinanciada: false, orden: 23,
        },
      ],
    };
  },

  methods: {
    async generarExcelEstimaciones() {
      this.estaCargando = true;
      const data = this.creaExcelEstimaciones;
      await this.mixGenerarExcel(data);
      this.estaCargando = false;
    },
    getEstatusPagoEstimacion(solicitud) {
      // Sin estatus
      if (!solicitud) {
        return {
          texto: 'No pagada',
          fecha: '',
        };
      }
      // Si ya tiene un pago mosrar que ya esta pagado
      if (solicitud.pagosDetalles.length > 0) {
        // Extraer el ultimo pago
        const ultimoPago = solicitud.pagosDetalles[solicitud.pagosDetalles.length - 1];
        return {
          texto: 'Pagado',
          fecha: new Date(ultimoPago.createdAt).toLocaleDateString(),
        };
      }
      // Si no tiene pago mostrar solicitado
      return {
        texto: 'Pagado', // se muestra como pagado por modificacion a modo en que se registran los pagos.
        fecha: this.$moment(solicitud.pagoSolicitud.fecha).format('DD-MM-YYYY'),
        folioPago: solicitud.pagoSolicitud.folio,
      };
    },
  },
  computed: {
    getEstimaciones() {
      if (!this.estimaciones) return [];
      return this.estimaciones.map((estimacion) => ({
        ...estimacion,
        estatusPago: this.getEstatusPagoEstimacion(estimacion.solicitudPago).texto,
        fechaPago: this.getEstatusPagoEstimacion(estimacion.solicitudPago).fecha,
        folioPago: this.getEstatusPagoEstimacion(estimacion.solicitudPago).folioPago,

      }));
    },
    getHeaders() {
      // Se valida si la obra es financiada para filtrar los headers
      // que corresponden a obra dinanciada
      if (this.contrato.esObraFinanciada) {
        const headersFiltrados = this.headers.map((headers) => headers.value);
        return headersFiltrados;
      }
      const headersFiltrados = this.headers.filter((headers) => !headers.esObraFinanciada)
        .sort((a, b) => (a.orden - b.orden))
        .map((headers) => headers.value);
      return headersFiltrados;
    },
    getColumnas() {
      if (this.contrato.esObraFinanciada) {
        const columnasFiltradas = this.headers.map((headers) => headers.nombreColumna);
        return columnasFiltradas;
      }
      const columnasFiltradas = this.headers.filter((headers) => !headers.esObraFinanciada)
        .sort((a, b) => (a.orden - b.orden))
        .map((headers) => headers.nombreColumna);
      return columnasFiltradas;
    },
    creaExcelEstimaciones() {
      const estimacionesExcel = [...this.getEstimaciones];
      const numEstimaciones = estimacionesExcel.length;
      const dataHeaders = this.getHeaders;
      const nombresColumnas = this.getColumnas;

      if (this.contrato.esObraFinanciada) {
        estimacionesExcel.push({
          fechaAl: {
            value: 'Totales',
            estilo: {
              font: {
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
          },
          importeCostoDirecto: {
            value: `=SUM(D2:D${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeCostoIndirectos: {
            value: `=SUM(E2:E${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeUtilidad: {
            value: `=SUM(F2:F${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeCargosAdicionales: {
            value: `=SUM(G2:G${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeEstimado: {
            value: `=SUM(H2:H${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeAmortizacionAnticipo: {
            value: `=SUM(I2:I${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          subtotal: {
            value: `=SUM(J2:J${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeCostoFinanciero: {
            value: `=SUM(K2:K${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          subtotalDos: {
            value: `=SUM(L2:L${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeIva: {
            value: `=SUM(M2:M${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          totalFactura: {
            value: `=SUM(N2:N${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeDeducciones: {
            value: `=SUM(O2:O${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeRetenido: {
            value: `=SUM(P2:P${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeDevuelto: {
            value: `=SUM(Q2:Q${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeSancion: {
            value: `=SUM(R2:R${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeBonificacion: {
            value: `=SUM(S2:S${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeLiquido: {
            value: `=SUM(T2:T${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
        });
      } else {
        estimacionesExcel.push({
          fechaAl: {
            value: 'Totales',
            estilo: {
              font: {
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
          },
          importeEstimado: {
            value: `=SUM(D2:D${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeAmortizacionAnticipo: {
            value: `=SUM(E2:E${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          subtotal: {
            value: `=SUM(F2:F${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeIva: {
            value: `=SUM(G2:G${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          totalFactura: {
            value: `=SUM(H2:H${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeDeducciones: {
            value: `=SUM(I2:I${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeRetenido: {
            value: `=SUM(J2:J${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeDevuelto: {
            value: `=SUM(K2:K${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeSancion: {
            value: `=SUM(L2:L${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeBonificacion: {
            value: `=SUM(M2:M${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
          importeLiquido: {
            value: `=SUM(N2:N${numEstimaciones + 1})`,
            tipo: 'formula',
            estilo: {
              font: {
                bold: true,
              },
            },
          },
        });
      }

      const data = {
        excelData: {
          configuration: {},
          header: {
            estilo: {
              font: {
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas: [...nombresColumnas],
            filaInicio: 2,
            data: [...estimacionesExcel],
          },
        },
      };
      return data;
    },
  },
};
</script>

<style>

</style>
